module.exports = __webpack_public_path__ + "assets/img/21_1120_big.6e882933.jpg";